import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {CountryLimit} from '~local/app/types/CountryLimit';
import {Observable} from 'rxjs';
import {DataSourceResponse, DataSourceService} from './DataSourceService';

@Injectable()
export class CountryLimitService extends DataSourceService<CountryLimit> {
    constructor(private http: HttpClient) {
        super();
    }

    public loadData(
        filter: string = '',
        orderBy: string = '',
        orderDirection: string = 'ASC',
        pageNumber: number = 0,
        pageSize: number = 10,
        globalFilter: string = null
    ): Observable<DataSourceResponse<CountryLimit>> {
        return this.http.get<DataSourceResponse<CountryLimit>>(
            '/admin/countrylimit/list/' + (globalFilter ? globalFilter : ''),
            {
                params: new HttpParams()
                    .set('filter', filter)
                    .set('orderBy', orderBy)
                    .set('sort', orderDirection.toUpperCase())
                    .set('skip', pageNumber.toString())
                    .set('take', pageSize.toString())
            }
        );
    }

    getCountryLimit(id: number): Observable<CountryLimit> {
        return this.http.get<CountryLimit>('/admin/countrylimit/limit/' + id);
    }

    saveCountryLimit(data: CountryLimit): Observable<any> {
        return this.http.post<any>('/admin/countrylimit/changelimit', data);
    }
}
